/**
 * useSite — resolves the currently-active sibling site + exposes a
 * few convenience helpers so components don't have to know how the
 * resolution works.
 *
 *   const { slug, profile, isHidden, isSectionAllowed } = useSite();
 *   if (isHidden("family_tree")) return null;
 */
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  resolveSiteSlug, siteProfile, isNavHidden, isPortalSectionAllowed,
} from "@/config/siteConfig";

export default function useSite() {
  const [params] = useSearchParams();
  const queryParam = params.get("site") || "";
  return useMemo(() => {
    const slug = resolveSiteSlug({ queryParam });
    const profile = siteProfile(slug);
    return {
      slug,
      profile,
      isHidden: (key) => isNavHidden(profile, key),
      isSectionAllowed: (secSlug) => isPortalSectionAllowed(profile, secSlug),
    };
  }, [queryParam]);
}
